import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import './CoverflowBase.css'

import InputBPM from './InputBPM';
import IMixAdd from '../svg/IMixAdd';
import IMixSub from '../svg/IMixSub';

function ContainerBPM({ bpmAutomix, autoBpmAutomix, autoBPM, setBPM }) {
  const onClick = (base) => {
    return (!autoBpmAutomix) ? base : () => {};
  }
  return (
    <div className={`flexRow cf-bpm-container`}>
      <div className={`flexRow cf-bpm space-around align type-regular fz12 `} >
        <IMixSub size={15} color={!autoBpmAutomix ? Config.TYPE_DARK_SECONDARY : Config.BLACK_5} className={`cf-bpm-actions ${autoBpmAutomix && 'noaction'}`} onClick={onClick(setBPM(-5))} />
        <InputBPM base={bpmAutomix} lock={autoBpmAutomix} />
        <IMixAdd size={15} color={!autoBpmAutomix ? Config.TYPE_DARK_SECONDARY : Config.BLACK_5} className={`cf-bpm-actions ${autoBpmAutomix && 'noaction'}`} onClick={onClick(setBPM(5))} />
        <span className={`fz12 cf-autobpm ${autoBpmAutomix ? `type-light` : 'type-black-5'}`} onClick={autoBPM} >Auto BPM</span>
      </div>
    </div>
  )
}

ContainerBPM.propTypes = {
  bpmAutomix: PropTypes.any,
  autoBpmAutomix: PropTypes.bool,
  setBPM: PropTypes.func,
  autoBPM: PropTypes.func,
}

export default ContainerBPM;
